// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionArticle_section__JNrsi","divider":"SectionArticle_divider__Dzqnj"};